export const environment = {
  production: true,
  hmr: false,
  debug: false,
  client: 'Infiniti-US',
  hostName: '',
  environmentName: 'production',
  appName: 'Infiniti-US Analytics',
  ssoPassword: 'ShiftDigital#123',
  defaultChartColors: ['#020B24', '#B0A591', '#A6A6A6', '#D9D9D9', '#CCCCCC'],
  applicationInsights: {
    instrumentationKey: '34e10784-8f5e-44ce-b880-6db10cb72c8b'
  },
  defaultLocale: 'en',
  availableLocales: ['en'],
  timeZone: 'Central Standard Time',
  numberOfMonthsToShowDefault: 12,
  numberOfQuartersToShowDefault: 8,
  defaultOrgLevelTypeIds: [1],
  closeRateLookbackMonths: 3,
  baseApiUri: 'https://infinitius-analytics-api-prod.azurewebsites.net/api',
  baseV5ApiUri: 'https://infinitius-analytics-apiv5-prod.azurewebsites.net/api',
  authUri: 'https://infinitius-analytics-api-prod.azurewebsites.net/token',
  retailerToolsIncludeAuth: true,
  retailerToolsBaseUri: 'https://infinitius-retailertools-web-prod.azurewebsites.net',
  mysteryShopBaseUri: 'https://mysteryshop.infinitidigitalprogram.com',
  favIconPath: '/assets/icons/clients/infiniti-us/favicon.ico',
  loginRedirectUrl: '',
  logoutRedirectUrl: '',
  sidebarDefaultOpen: true,
  useV5WebsiteOverview: false,
  v5Reports: [
    'LeadsOverview',
    'LeadTransactionsOverview',
    'SalesOverview',
    'WebsiteOverview',
    'DigitalRetailingOverview',
    'ChatOverview',
    'DigitalAdvertisingDashboard'
  ]
};
